module.exports = __webpack_public_path__ + "assets/bottom-nav-cart.77a79936.svg";